import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Wrapper = ({ icon, title, message, onCountdownComplete, type }) => {
  const [seconds, setSeconds] = useState(3);

  useEffect(() => {
    if (seconds === 0) {
      // onCountdownComplete();
      window.parent.postMessage(
        {
          type: type, // or 'PAYMENT_FAILED'
        },
        '*'
      );

      return;
    }

    const timer = setTimeout(() => setSeconds(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds, onCountdownComplete]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="60vh"
      px={2}
    >
      {icon}
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={2}>
        {message}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Redirecting you to merchant in {seconds} second{seconds !== 1 ? 's' : ''}...
      </Typography>
    </Box>
  );
};

export const PaymentReceivedScreen = ({ formData, onContinue }) => (
  <Wrapper
    type={'PAYMENT_SUCCESS'}
    icon={<CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />}
    title="Payment Received"
    message={`Thank you, ${formData?.fullName || 'Attendee'}! Your payment has been successfully processed.`}
  // onCountdownComplete={onContinue}
  />
);

export const PaymentFailedScreen = ({ onRetry }) => (
  <Wrapper
    type={'PAYMENT_FAILED'}
    icon={<ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />}
    title="Payment Failed"
    message="Oops! Something went wrong while processing your payment. Please try again."
  // onCountdownComplete={onRetry}
  />
);
